"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import { useEffect } from "react"
import { useQuery } from "@apollo/client/react"
import listUserOrganizations, {
  type ListUserOrganizationsQueryVariables,
} from "../graphql/queries/listUserOrganizations"
import { GET_ORGANIZATION } from "../graphql/queries/getOrganization"
import { handleQueryError } from "../lib/logging"
import useSessionAttributes from "../lib/auth/useSessionAttributes"

type ListUserOrganizationsQuery = {
  listUserOrganizations?: {
    edges?: Array<{ node: Record<string, unknown> } | null | undefined>
  }
}

type GetOrganizationQuery = {
  getOrganization?: {
    nodes?: Array<Record<string, unknown> | null | undefined>
  }
}

/**
 * Hook to get the user's organization list and current organization details
 */
export default function useMyOrganizationList(
  userId: string | number | undefined,
  orgId: string | undefined,
  options?: { enabled?: boolean },
) {
  const { isAuthenticated } = useSessionAttributes()
  const enabled = isAuthenticated && options?.enabled !== false
  const numericUserId =
    typeof userId === "number"
      ? userId
      : typeof userId === "string" && userId !== ""
        ? Number.parseInt(userId, 10)
        : null
  const hasValidUserId = Number.isInteger(numericUserId)

  // Fetch all user organizations
  const {
    data: listUserOrganizationsData,
    loading: loadingOrgs,
    error: listOrgsError,
  } = useQuery<ListUserOrganizationsQuery, ListUserOrganizationsQueryVariables>(
    listUserOrganizations,
    {
      variables: {
        pUserId: hasValidUserId ? (numericUserId as number) : 0,
      },
      skip: !enabled || !hasValidUserId,
    },
  )

  useEffect(() => {
    if (listOrgsError) handleQueryError(listOrgsError)
  }, [listOrgsError])

  const organizations =
    (enabled
      ? listUserOrganizationsData
      : undefined
    )?.listUserOrganizations?.edges?.map((edge) => edge?.node) || []

  // Fetch current organization details using session orgId
  const {
    data: organizationData,
    loading: loadingCurrentOrg,
    error: organizationError,
  } = useQuery<GetOrganizationQuery>(GET_ORGANIZATION, {
    variables: {
      pOrgId: orgId,
    },
    skip: !enabled || !orgId,
  })

  useEffect(() => {
    if (organizationError) handleQueryError(organizationError)
  }, [organizationError])

  const currentOrganization = ((enabled ? organizationData : undefined)
    ?.getOrganization?.nodes?.[0] ?? undefined) as
    Record<string, unknown> | undefined
  const currentOrgIsPersonal = currentOrganization?.isPersonal || false

  // Resolve the current user's role within the active org
  const currentOrgRole =
    (organizations.find((org) => org && String(org.orgId) === String(orgId))
      ?.role as string | null | undefined) ?? null

  return {
    organizations,
    currentOrganization,
    currentOrgIsPersonal,
    currentOrgRole,
    loading: loadingOrgs || loadingCurrentOrg,
  }
}
